export default {
  route: {
    visitor: 'Visitor',
    data: 'Data',
    employee: 'Employees',
    role: 'Role',
    visitlist: 'Visitlist',
    backlist: 'Blacklist',
    whitelist: 'Whitelist',
    notice: 'Notice',
    pad: 'Reception',
    reserve: 'Reservation',
    approve: 'Approval process',
    key: 'Door Access',
    meeting: 'Conference',
    account: 'Account',
    order: 'Invite',
    orderList: 'Invitelist',
    history: 'History',
    404: '404',
    calendar: 'Calendar',
    overtime: 'Work overtime',
    vset: 'Visittype',
    signup: 'Signup'
  },
  pwdStrong: 'Strong',
  pwdMedium: 'Medium',
  pwdWeak: 'Weak',
  plateNum: 'Plate number',
  belongings: 'Belongings',
  onUse: 'Available',
  tagText: 'Tag',
  tagTitle: 'Custom labels',
  tagDesc: 'User-defined labels',
  carNumber:'Plate number',
  peopleSearch: 'Employee',
  Approve: 'Approve',
  ApproveSuccess: 'Send approve successfully!',
  newApprove: 'New approval flow',
  level: 'Level',
  defaultInterviewPerson: 'Default receiver',
  onWorkManager: 'The manager on work',
  operator: 'Operator',
  operatorSet: 'Operator setting',
  oneleast: 'Add at least one.',
  mostFive: 'At most 5.',
  tempNameNotNull: "Template's name can't blank",
  roleNameNotNull: "Role's name can't blank",
  roleGroupNameNotNull: "The role group name can't blank",
  loading: 'Loading',
  tempName: 'Template name',
  comAddEmpShowText: 'Please select departments to add staff.',
  passRecord: 'Pass record',
  idcard: 'ID card',
  carId: "Driver's license",
  passport: 'Passport',
  officialCard: 'Military id',
  jobCard: 'Work card',
  others: 'Others',
  filePhoto: 'Photos',
  certType: "Card's type",
  carrytools: 'Tools',
  registinformation: 'Registration information',
  normalText: 'Normal',
  errorText1: 'Error',
  equipCode: 'Equipment number',
  item: '',
  youCanUse: 'you can use',
  youUsed: 'You have used',
  engineRoom: 'engine-room',
  unengineRoom: 'Non-engine room',
  authorArea: 'Authorized area',
  visitArea: 'Visitting area',
  AreaTitle: 'Area',
  addAreaGroup: 'Add area group',
  updateAreaGroup: 'Update area group',
  confirmBtn: 'Comfirm',
  refuseBtn: 'Refuse',
  agentName: 'Agent',
  agentStatus: 'Agent status',
  selectAgent: 'Please select an agent',
  visitTypeText: 'Visitor type',
  pleaseInputVtype: 'Please input visitor type',
  pleaseSelectVtype: 'Please select visitor type',
  pleaseSelectVisittype: 'Please select visitor type',
  addVtype: 'Add visitor type',
  editVtype: 'Edit visitor type',
  vtypeSetTitle: "Visitor's type setting",
  vtypeSetDesc: 'You can add a type of visitor',
  peopleNo: 'Personnel number',
  endedStatus: 'Ended',
  direction: 'Direction',
  pleaseDepart: 'Please select department',
  endVisitTime: 'The time of ending visit',
  sendError: 'Send error',
  waitApprove: 'Pending',
  signOutText: 'Signout',
  exportEmpList: 'Export employee datas',
  twoCharter: 'Please enter 2 digits',
  selectOneMore: 'Choose at least one',
  departNo: 'Department number',
  faceError: 'Face recognition failed',
  takePhoto: 'Take a photo',
  floorArray: ['Low','Mid','High'],
  confirmStopEmp: 'Are you sure that the employee is out of service',
  portrait: 'Portrait',
  empTitle: 'Employee details',
  goInTime: 'Entry time',
  goLeaveTime: 'Departure time',
  dataError: 'Data error',
  dataSuccess: 'Data success',
  onWorkReason: 'The reason of work overtime',
  cardidIsNotNull: 'ID cannot be empty',
  cardidIsError: 'ID number must be 18 digits',
  visitSetTime: "Visit's time setting",
  visitSetTimeDesc: 'Visitors can only visit during this time period.',
  visitStartTime: 'Starting time',
  visitEndTime: 'End Time',
  date: 'Date',
  onWorkday: 'Overtime',
  agree: 'Agreed',
  refuse: 'Refused',
  unresolve: 'Unapproved',
  CheckAll: 'Check all',
  workbayIsNotNull: 'Office floor cannot be empty',
  workdayset: 'Working day setting',
  workdaydesc: 'You can set working day and holiday',
  dateSet: 'Date setting',
  setStyle: 'Style',
  workday: 'Workday',
  playday: 'Playday',
  addWhiteBtn: 'Add a whitelist',
  basicset: 'Basic settings',
  editVisitor: 'Edit visitors',
  Proxysettings: 'Proxy settings',
  Proxylist: 'Proxy list',
  downloadprotocol: 'Download',
  Signprotocol: 'Signature protocol',
  vCardType: "The Type of Visitor's card type",
  commonText: 'Common',
  customized: 'Customized',
  logoTypeText: "Logo's type",
  logoPositionTop: 'Top',
  logoPositionBom: 'Bottom',
  logoPositionMid: 'Middle',
  isShowAvatar: 'Whether or not portrait is displayed',
  logoText: 'Words',
  logoImage: 'Image',
  logoTypePosition: "Logo's position",
  portraitType: "Portrait's type",
  userPhoto: "User's picture",
  fixedPhoto: "Fixed picture",
  codePhoto: 'QR code',
  codeText: "QR code's text",
  customText: 'Custom text',
  badgeCustom: 'Custom name',
  empAuthor: 'Employee authorization',
  sendType: 'The type of sending invitation',
  sendTypeIsNull: 'The type of sending invitation is not blank',
  overviewVCard: "visitor's card preview",
  clickHere: 'click here ',
  daysRange: 'Number of days',
  timesRange: 'Frequency range',
  daysUpTip: 'The number of effective days cannot exceed the upper limit set via the company',
  timesUpTip: 'The number of valid times cannot exceed the upper limit set via the company',
  saveMoban: 'Please edit template',
  insertAddress: 'Please input address',
  successText: 'Success',
  errorText: 'Fail',
  uptoMax: 'Cannot exceed the upper limit',
  inviteTip: 'If add more visitors,only overview the first',
  inviteMoban: 'Invite SMS template',
  searchVnameHolder: "Search visitor's name",
  uploadFileSuccess: 'Upload file successfully',
  uploadFileError: 'Upload file failed',
  fileFormatError: 'File format is incorrect',
  mustSelect: 'Please select',
  selectCard: 'Please input card number',
  noPage: 'Sorry,the page is not found!',
  syncSuccess: 'Synchronization success',
  activeSuccess: 'Active successfuly!',
  tipEmp: 'Username must include \\',
  switchSuccess: 'The switch is set up successfully!',
  updateSuccess: 'The modification is successful!',
  addSuccess: 'App successfuly',
  setSuccess: 'Set up successfuly!',
  signOutSuccess: 'Sign out success',
  sendFaceSuccess: 'Face success',
  regFaceSuccess: 'Face registration success',
  sendCardSuccess: 'Batch card success',
  deleteSuccess: 'Delete successfuly!',
  updateSuccess: 'Data update successfuly',
  selectProject: 'Please select a project',
  uploadPicSuccess: 'Upload picture successfuly',
  uploadPicError: 'Upload picture failed',
  picFormatError: 'Image format is incorrect',
  emailOrderSuccess: 'Mail subscriptions have been set up successfully',
  pwdSuccess: 'Password reset successfully',
  pwdResetSuccess: 'Password modify successfully',
  pwdInitSuccess: 'Password initialise successfully',
  comSuccess: 'The success of multi company service mode modification',
  lessOneGate: 'Less one gate',
  floorNumber: 'Floor',
  roomNumber: 'Room',
  comSelectHolder: 'Please select one company',
  comNameHolder: 'Please input company name (6 letters)',
  teamName: 'Team Name',
  teamNumber: 'Team Counts',
  cemail: 'Email',
  doneBtn: 'Done',
  newInputItem: 'New Input',
  newSelectItem: 'New Select',
  moveSort: 'Sort',
  editPhoto: 'Update photo',
  pcSetting: 'PC Settings',
  teamText: 'Team',
  goBackIndex: 'Return home',
  selectEmpTip: 'Please select employee',
  passText: 'Password',
  months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
  weeks: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
  comfirmPassText: 'Confirm password',
  signOutWinTitle: 'sign out window',
  switchLanguage: 'Language switching is successful!',
  sendSmsCode: 'Send code',
  smsCode: 'code',
  reget: 'Reacquire',
  isLeave: 'Confirm leave?',
  visittype: 'Visit type',
  visitcause: 'The reason for the visit',
  visitData: 'Visitor data',
  visitCount: 'Visitor counts',
  recepaccount: 'Reception account',
  contactvtype: 'Select linked visit type',
  contactvtype1: 'link the visit type',
  semp: 'Select employee',
  scopy: 'Select copy',
  nextStep: 'The next step',
  prevStep: 'Previous',
  emptip: 'Please select an employee as the default cc person (can not choose)',
  sempholder: 'Search employee name or card number',
  sempholder1: 'Search employee name',
  as: 'Categorized as',
  defaultText: 'default',
  chargePerson: 'The person in charge',
  chargePersonPhone: 'TEL of the person in charge',
  workArea: 'Working area',
  workcontent: 'Working content',
  gender: 'gender',
  age: 'age',
  Projectselect: 'Project selection',
  busdepartment: 'Business department',
  startTime: 'Starting time',
  endTime: 'End Time',
  pronameIsBlank: 'Project name cannot be empty',
  comnameIsBlank: 'Company name cannot be blank',
  chargeIsBlank: 'The person in charge cannot be empty',
  chargePhoneIsBlank: 'The person in charge cannot be empty',
  dateIsBlank: 'Date cannot be blank',
  moreOneVisit: 'Select up to one visitor',
  selectVisit: 'Please select visitors',
  downloading: 'downloading……',
  faceError: 'Face registration failed, please re-register the picture',
  regPhoto: 'Registration photo',
  uploadComLogo: 'Upload company logo',
  newtext: 'New',
  h1text: 'Add approval process settings',
  h2text: 'Part of the function optimization;',
  h3text: 'Gate setting',
  h4text: 'Add guest and blacklist modules',
  h5text: 'Settings for new security protocol',
  h6text: 'Add conference management, increase some functions, such as conference room and view of conference room reservation records;',
  h7text: 'Optimize the employee login process. Employees need to activate their accounts and set passwords for the first time.',
  h8text: 'Add the functions of sign-in visitors, reserved visitors, inviting visitors to view and the search for the current visitor list to the visitor page.',
  h9text: 'Increase the function of batch sign-out.',
  h10text: 'Employees‘ exclusive links are cancelled. Employees can get the initial password and log in directly to the employee’s exclusive page for invitation.',
  h11text: 'The settled companys log in. The subsidiary companies in multi-company service model can log in and enter the exclusive page of the subsidiary company to view visitors‘ records.',
  h12text: 'Optimize the page layout of the "Custom Settings".',
  h13text: 'Increase the mode of meeting management.',
  h14text: 'Increase the function of sign-out via ID Nr, modify and perfect the sign-in process and mode via ID Nr.',
  h15text: 'Modify and improve the search and export functions.',
  h16text: 'Add the way of code scanning via ID Nr.',
  h17text: 'Add the app client for visitor verification.',
  h18text: 'Add the switch configuration page.',
  h188text: 'Added visitor statistics for the current day',
  h19text: 'Add the statistics of the number of visitors on the same day.',
  h20text: 'Add a sign-in function via QR Code scanning.',
  h21text: 'New page reversion',
  h22text: 'Add the Account Information - company Service Model: The multi-company service model is suitable for various types of company service providers, such as maker space, joint office space, property, office building and so on. It can provide the front desk display and visitor management service for the settled companys.',
  h23text: 'Add the recharge management function.',
  h24text: 'When SMS exceeds the user quota, different SMS packages can be purchased.',
  h25text: 'Check the distribution of the use of SMS.',
  h26text: 'Issue an invoice for the purchase of SMS order.',
  h27text: 'Add a reservation function.',
  h28text: 'Support sending a reservation SMS to visitors, including reservation details, traffic parking and other information.',
  h29text: 'The staff can edit according to the template and send the invitation to the reserved visitor.',
  h30text: 'When arriving, the visitor can enter the four numbers of his TEL so that he can quickly register.',
  h31text: 'Add a batch reservation function. Multiple reservations can be imported through the Excel table.',
  h32text: 'Add a notification mode of “DingTalk” (how to configure DingTalk), and support the import of employee contacts through “DingTalk”.',
  h33text: 'Add the function of “You have visited before”. Visitors only need to enter the TEL to sign in when they visit again.',
  h34text: 'The staff can edit according to the template and send the invitation to the reserved visitor.',
  h35text: 'Add the size of the visitor stickers and more custom settings for the contents.',
  h36text: 'Add the function of team visit.',
  h37text: 'Start using a new logo for “Cool Visit”.',
  h38text: 'Turn on the function of SMS notification.',
  h39text: 'Add the function of visit information search, and support the statistical analysis of “visiting reason”.',
  h40text: 'Add the editing function for the special account (what is a special account).',
  h41text: 'Modify the email notification function, and choose the default configuration, SMTP or Exchange.',
  h42text: 'Support the setting of QR Code as the avatar of the visitor.',
  h43text: 'Add the text function of the visitor sticker.',
  h44text: 'Function of visitor page: Support the calendar to view the visitor information on the same day.',
  h45text: 'Function of employee page: Support the mode of importing employee information through manual operation, RTX or Excel table and batch modification can be done.',
  h46text: 'Function of notification page: Provide three kinds of notification methods via WeChat, RTX and mail, and set a specific receiving mode via the switch.',
  h47text: 'Custom settings - company image page: Support the custom settings for company logo, carousel picture on the first screen of iPad, the color of iPad appearance and visitor avatar.',
  h48text: 'Custom settings - visitor registration page: Support the custom settings for visitor registration information and the entries and options can be created.',
  resetPwd: 'reset Password',
  inputNewPwd: 'Please enter the new password for the account',
  submitNewPwd: 'Submit new password',
  yourName: 'Your name',
  yourPhone: 'Your TEL',
  yourMobile: 'Your TEL',
  yourCompany: 'Your company',
  yourVisitor: 'People you want to visit',
  youVisittorPhone: 'People’s TEL you want to visit',
  qrcodeDown: 'QRcode download',
  appStoreDown: 'App Store download',
  localDown: 'Local download',
  downtip1: 'Please use Pad to scan the QR Code on the upper side to download, or download the client of “Cool Visit” from App Store and Local Download.',
  downtip2: 'Please turn on “Cool Visit” and log in with your registered email address *',
  downtip3: 'Try to register information with the identity of a visitor and try to run the “Cool Visit”.',
  loginselect: ['Administrator', 'HQ Administrator', 'Subcompany', 'Employee', 'Reception'],
  login: {
    title: 'Administrator',
    logIn: 'Sign in',
    username: 'account',
    password: 'password',
    forgot: {
      title: 'Forgot Password?',
      page: {
        title: 'Forgot Password',
        desc: 'Please enter your email address and we will send you instructions on how to reset your password.',
        desc1: 'Please enter the TEL, get the verification code',
        desc3: 'Reset your password',
        desc2: 'Reset password successfully!',
        desc4: 'Activate the account successfully!',
        btn: 'Send a reset link'
      }
    },
    or: 'or',
    signup: 'company Registration',
    active: 'Activate the account'
  },
  validName: {
    tip: 'The format of the super account is incorrect, beginning with LFT_'
  },
  signup: {
    title: 'Sign up',
    desc: 'Immediately experience a more intelligent visitor management system',
    button: 'Sign up'
  },
  navlist: [{
    name: 'Visitors',
    dirname: 'index',
    link: 'index',
    children: []
  }, {
    name: 'Emplist',
    dirname: 'emp',
    link: 'emp',
    children: [{
      name: 'Company Employee',
      dirname: 'emp',
      link: '/emp',
      children: []
    }, {
      name: 'Resident Visitors',
      dirname: 'emp',
      link: '/visitlist',
      children: []
    }, {
      name: 'Blacklist',
      dirname: 'emp',
      link: '/blacklist',
      children: []
    }, {
      name: 'Whitelist',
      dirname: 'emp',
      link: '/whitelist',
      children: []
    }, {
      name: 'Work overtime query',
      dirname: 'emp',
      link: '/whitelist',
      children: []
    }]
  }, {
    name: 'Notification',
    dirname: 'notice',
    link: 'notice',
    children: []
  }, {
    name: 'Settings',
    dirname: 'setting',
    link: 'setting.html',
    children: [{
      name: 'Reception',
      dirname: 'setting',
      link: '/pad',
      children: []
    }, {
      name: 'Basic settings',
      dirname: 'setting',
      link: '/reserve',
      children: []
    }, {
      name: 'Intelligent Door Access',
      dirname: 'setting',
      link: '/key',
      children: []
    }]
  }, {
    name: 'Conference ',
    dirname: 'meeting',
    link: 'meeting',
    children: []
  }],
  empnav: [{
    name: 'Invitation',
    dirname: 'order',
    link: '',
    children: []
  }, {
    name: 'Invitation List',
    dirname: 'list',
    link: 'list',
    children: []
  }],
  downlist: ['Settings', 'Update Pasword', 'Log out'],
  form: {
    name: {
      text: 'Name',
      text1: 'visitor',
      text2: 'interviewee',
      text3: 'nickname',
      text4: 'operator',
      text5: 'type of operator'
    },
    depart: {
      text: 'department'
    },
    phone: {
      text: 'TEL',
      text1: 'information of contact',
      text2: 'interviewee’s contact information',
      text3: 'TEL',
      text4: 'TEL'
    },
    idnum: {
      text: 'ID Nr.',
      text1: 'Certificate No.',
      text2: 'scanning copy of the certificate'
    },
    email: {
      text: 'Email',
      checktext: 'Subscribe to email',
      tiptitle: 'Are you sure you will not receive the mail?',
      tipdesc: 'Check this item to <strong>indicate</strong> that no mail will be accepted after visiting.'
    },
    company: {
      text: "Co.'s name",
      text2: 'company',
      text1: 'office',
      text3: 'Affiliated company'
    },
    companypro: {
      text: "Co.'s abbr.",
      text2: 'work unit'
    },
    position: {
      text: 'position',
      text1: 'work number'
    },
    password: {
      oldtext: 'Old password',
      newtext: 'New password',
      retext: 'Confirm new password',
      text1: 'Password',
      comtext: 'This is the initialized password, so please modify it in time to prevent information leakage.'
    },
    stageaccount: {
      text: 'Verification account'
    },
    count: {
      text: 'Number of visitors',
      text1: 'List of follow-up personnel'
    },
    remark: {
      text: 'remark'
    },
    time: {
      text6: 'time',
      text: 'Sign-in time',
      text1: 'Sign-out time',
      text2: 'Time of reservation',
      text3: 'Time of invitation',
      text4: 'term of service',
      text5: 'operation time',
      text7: 'term of validity'
    },
    gate: {
      text: 'associate the gate group',
      tip: 'Please choose the gate',
      text1: 'gate information',
      text2: 'Please choose the associated gate unit',
      text3: 'The associated gate unit'
    },
    photo: {
      tip: 'Please upload a head portrait'
    },
    visitType: {
      text: 'the type of the visit'
    }
  },
  btn: {
    editBtn: 'Edit',
    createNow: 'Immediate creation',
    shouBtn: 'Take up',
    visible: 'visible',
    backListBtn: 'Return list',
    saveBtn: 'Save',
    addBtn: 'Add',
    addSelectBtn: 'Add options',
    saveAndBtn: 'Save and continue to add',
    exportBtn: 'Export datas',
    export: 'Export',
    overview: 'Preview',
    searchBtn: 'Search',
    picBtn: 'Select a picture',
    addBlackBtn: 'Add a blacklist',
    dotDeleteBtn: 'Batch delete',
    dotUpdateBtn: 'Batch modification',
    editSpecial: 'Edit special account',
    dotSendCard: 'Batch card',
    sendFaceBtn: 'Send the whole face',
    addProjectBtn: 'Add item',
    editProjectBtn: 'Editing project',
    moveProjectBtn: 'Adjust the project',
    addVisitorBtn: 'Add visitors',
    cardBtn: 'Generating a visitor card',
    updateBtn: 'Modify',
    deleteBtn: 'Delete',
    insetBtn: 'Required',
    initPwdBtn: 'Initialization cipher',
    cancelBtn: 'Cancel',
    haveCancel: 'Cancelled',
    confirmBtn: 'Confirm',
    edit1: 'Operation',
    addComBtn: 'Add a company',
    downMobanBtn: 'Download template',
    uploadComBtn: 'Uploading company',
    uploadlgo: 'Upload logo',
    uploadExcel: 'Upload excel',
    addMeeting: 'Add a new meeting',
    editMeeting: 'Management of meetings',
    saveMobanBtn: 'Save template',
    sendInvite: 'Send a meeting invitation',
    addDepartBtn: 'Add subdivision',
    addEmpBtn: 'Add staff',
    editEmpBtn: 'Employee editors',
    exportListBtn: 'Importing the address book',
    editDepart: 'Editorial department',
    moveDepart: 'Adjustment department',
    synBtn: 'Synchronization',
    addRoleGroup: 'New role group',
    addRole: 'New role',
    editGroup: 'Role group editor',
    editRole: 'Role editing',
    addMember: 'Add members',
    batchOut: 'Batch sign out',
    sendInvite: 'Send invitations',
    clickUpload: 'Click and upload',
    uploadWait: 'Please wait……'
  },
  moban: {
    text: 'Launch a conference',
    text1: 'invitation record of the meeting',
    tip: 'send invitation successfully',
    tip1: 'You look at the invitation list at the conference invitation record list',
    tip2: 'Got it',
    tip3: 'Conference content',
    tip4: 'Conference address',
    tip5: 'Add at least one visitor',
    tip6: 'Add at least one visitor information',
    visitMess: 'visitor’s information',
    address: 'Company address',
    traffic: 'Parking information and surrounding traffic',
    compro: 'Company profile',
    inviteLink: 'Invitation link',
    single: 'Individual invitation',
    dot: 'Batch invitation',
    facemoban: 'Interview template',
    busmoban: 'Business template',
    ctitle: 'Please fill in the relevant information of visitors, and then the SMS invitation can be generated and sent to the TEL of the other side.',
    cdesc: 'More related information about the company in the SMS invitation',
    tip7: 'You can choose one via one editing or batch import through Excel.',
    mtitle: 'Invite more company related information in SMS',
    emptip: 'Restrict staff edit switch to open, template can not be edited.',
    hello: 'Hello!',
    hello1: 'Sincerely invite you to come',
    hello2: 'Please click the invitation for details',
    interview: {
      title: 'The content of the invitation',
      desc: 'Writing specifications such as: {visitor}visitor name, {company}company name,{empid}reserved employee ID cannot be modified',
      defaultMoban: '<p>尊敬的{visitor}：</p><p style="text-indent:24px">您好！</p><p style="text-indent:24px">这里是{company}，感谢您对我公司的信任和选择。通过对您简历的认真审核，我们认为您已具备进入下一轮筛选的资格。为了进一步了解，现邀请您参加面试，具体安排如下：</p><br/>'
    },
    business: {
      title: 'The content of the invitation',
      desc: '书写规范形如:{visitor}来访者名字、{company}公司名称、{empid}预约员工id不可修改',
      defaultMoban: '<p>尊敬的{visitor}：</p><p style="text-indent:24px">您好！</p><p style="text-indent:24px">我是{company}的{empid}，很高兴代表我司与您联系。为更好的沟通交流工作事宜，诚挚希望与您进行会面，期待您的来访！</p><br/>'
    }
  },
  tablehead: ['#', 'Conference name', 'time', 'Initiator', 'theme', 'QR code', 'TEL', 'Cause', 'Launch time', 'company', 'status', 'Sending State'],
  formCheck: {
    validPassword: {
      tip1: 'Incorrect password format',
      tip2: 'The password length is not less than 6 bits',
      tip3: 'The password can not be empty',
      tip4: 'Please input a password',
      tip5: 'Two input password inconsistencies',
      tip6: 'Please enter the password again'
    },
    validEmail: {
      tip1: 'Incorrect mailbox format',
      success: 'Email is successful!',
      holder: 'email',
      tip2: 'Mailbox cannot be empty'
    },
    validphone: {
      tip1: 'The format of the TEL is not correct',
      tip2: 'Cell TEL can not be empty',
      holder: 'TEL'
    },
    validCompany: {
      tip1: 'The name of the company can not be empty',
      tip2: 'The Department can’t be empty'
    },
    validCompanyPro: {
      tip1: 'The company can not be short for short',
      tip2: 'The longest 6 characters'
    },
    validName: {
      tip1: 'The name cannot be empty',
      tip2: 'Contain illegal characters',
      tip3: 'The name cannot be empty',
      tip4: 'Please choose the sponsor of the conference',
      tip5: 'Employee name can not be empty',
      tip6: 'Depart name can not be empty',
      tip7: 'Project name can not be empty',
      tip8: 'Depart number can not be empty'
    },
    validEmpName: {
      holder: 'Employee name'
    },
    validAccont: {
      tip1: 'Please enter the account number'
    },
    time: {
      tip1: 'Please check the time',
      tip2: 'The date can not be empty',
      minute: 'minute',
      day: 'day',
      times: 'second'
    },
    meeting: {
      tip1: 'Please fill in the theme'
    },
    remark: {
      tip1: 'Please fill in the notes'
    }
  },
  timetype: [{
    label: 'Number of days',
    value: 0
  }, {
    label: 'frequency',
    value: 1
  }],
  itype: [{
    label: 'Interview',
    value: 0
  }, {
    label: 'Business affairs',
    value: 1
  }],
  checkVtype: ['all', 'Visitor’s name', 'Interviewee’s name', 'Purpose of Visit', 'TEL', 'company', 'Security','Visittype','Visitor Company'],
  outTip: {
    title: 'Do you confirm the withdrawal?',
    desc: 'tip',
    conform: 'confirm',
    cancel: 'cancel'
  },
  meeting: {},
  nodata: 'no data',
  dataM: 'Data Analytics',
  vstatus: ['Sent', 'Signed in', 'Viewed', 'Accepted', 'Refused', 'Signed out', 'Unauthorized', 'Authorized', 'Reserved', 'Expired'],
  vtype: ['Sign-in visitors', 'Reserved visitors', 'Invited visitors', 'Resident visitors'],
  vnum: ['Total', 'Left', 'Visiting', 'Total', 'Sign-in', 'Absent', 'Visitor'],
  vdate: ['Start date', 'End date', 'Selection date'],
  vtime: ['start time', 'End time'],
  visitor: {
    vname: 'the name of the visitor',
    vphone: 'Visitor’s TEL',
    vcom: 'Visitor company',
    ename: 'Name of the interviewee',
    ephone: 'TEL of the interviewee',
    ecom: 'Company of the interviewee',
    ordertime: 'the reservation time',
    visittime: 'Time of visit',
    leavetime: 'Time of departure',
    followPeople: 'follow-up personnel',
    list: 'Details',
    manager: 'Director',
    editEmp: 'Editors'
  },
  export: {
    title: 'Visitor list export item settings'
  },
  signStatus: ['Signed in', 'Signed out', 'Reserved', 'Expired', 'Sent', 'Viewed', 'Accepted', 'Refused', 'Authorized', 'Unauthorized'],
  record: 'Found',
  record1: 'in total，about',
  record2: 'Record',
  version: [{
    type: 0,
    name: 'free'
  }, {
    type: [1, 2],
    name: 'Business'
  }, {
    type: 3,
    name: 'Factory'
  }],
  endTimeText: 'expired',
  guide: {
    guide1: {
      title: 'Welcome to join us',
      desc: 'You only need to complete the following operations to customize the Cool Visit. For help, please click on the “Consultation” on the right side of the page.',
      inputTitle: 'Please fill in the information about the company',
      inputPlaceholder: 'Company name remarks (up to six words)',
      inputDesc: 'Prompt: The remark of the company name is used for WeChat and visitor stickers',
      next: 'Next: Notification settings',
      btn: 'Next'
    },
    guide2: {
      title: 'Add employee information',
      desc: 'After adding the employees, you can experience our most powerful function: to automatically notify the employees of the visitors. Please add at least one piece of employee information. Support RTX and the Excel import of the employee address book. It’s more recommended that you can try to add via hand, and directly enter the employee information into the backstage.',
      inputTitle: 'Please fill in the information about the company',
      inputPlaceholder: 'Company name remarks (up to six words)',
      inputDesc: 'Prompt: The remark of the company name is used for WeChat and visitor stickers',
      next: 'Next: Notification settings',
      btn: 'Next'
    },
    guide3: {
      title: 'Registration content setting',
      desc: 'Your visitors will register on the iPad page. We will provide you with the following registration contents, and you can personalize it.',
      inputTitle: 'Please fill in the information about the company',
      inputPlaceholder: 'Company name remarks (up to six words)',
      inputDesc: 'Prompt: The remark of the company name is used for WeChat and visitor stickers',
      next: 'Next: Notification settings',
      btn: 'Next'
    },
    guide4: {
      title: 'Notification mode setting',
      desc: 'We will provide you with five modes of notification, WeChat, email, DingTalk, RTX and SMS. Please click on the switch on the right to set up the way the employee receives the notification.',
      inputTitle: 'Please fill in the information about the company',
      inputPlaceholder: 'Company name remarks (up to six words)',
      inputDesc: 'Prompt: The remark of the company name is used for WeChat and visitor stickers',
      next: 'Next: Welcome the visitors',
      btn: 'Next'
    },
    guide5: {
      title: 'Pad terminal settings',
      desc: 'Your visitors will register on the iPad page. We will provide you with the following registration contents, and you can personalize it.',
      inputTitle: 'Please fill in the information about the company',
      inputPlaceholder: 'Company name remarks (up to six words)',
      inputDesc: 'Prompt: The remark of the company name is used for WeChat and visitor stickers',
      next: 'Next: Welcome the visitors',
      btn: 'enter background management'
    }
  },


  phoneIdnum: {
    text: '*ID Nr and mobile number choose one',
    tips: 'Make at least one TEL and ID Nr'
  },
  sex: ['male', 'Female'],
  idNumTip: ['Verification passed!', 'the number of your ID Nr is incorrect!', "ID Nr birth date is out of range or contains illegal characters!", "ID Nr verification error!", "ID Nr Area illegal!"],
  people: {
    emp: 'Employee',
    visit: 'Visitor',
    inviteVisit: 'Invite visitors',
    orderVisit: 'Check-in visitor',
    and: 'And'
  },
  status: {
    on: 'Enable',
    forbid: 'Forbidden',
    off: 'Disabled',
    text: 'Status',
    startText: 'Open state'
  },
  key: {
    htitle: 'Equipment Management',
    title: 'Device Information',
    ctitle: 'Equipment team member',
    ctitle1: 'Device List',
    title1: 'Open log',
    ctitle2: 'Device open record',
    addGroup: 'Add device group',
    updateGroup: 'Modify device group',
    groupName: 'Group name',
    groupId: 'Group number',
    groupRule: 'Service regulations',
    groupAuth: 'Access authority',
    groupStatus: 'Default opening after authorization',
    addEquip: 'Add Equipment',
    equipeName: 'Equipment name',
    equipMark: 'Equipment identification',
    extendMark: 'Extension identification',
    doorNumber: 'Door number',
    equipIp: 'Equipment IP',
    equipPort: 'Equipment port number',
    headNumber: 'Read head number',
    equipDist: 'Distribution of equipment group'
  },
  black: {
    wins: {
      title: 'New blacklist'
    }
  },
  pad: {
    usualSet: 'General settings',
    padSet: 'Pad settings',
    scolor: 'Choose',
    inputColor: 'Input the color value'
  },
  notice: {
    tip: {
      title: 'Notifications',
      desc: 'Please click on the switch on the right to set up the way the employee receives the notification.'
    },
    black: {
      title: 'Blacklist switch',
      desc: 'After the blacklist function is turned on, people in the blacklist will not be able to make an reservation or to register.',
    },
    weixin: {
      title: 'WeChat',
      desc: 'When a visitor signs in, notify the employee through the WeChat service account “Cool Visit”. The employee should have registered with the TEL in the address book on the service account ahead of time.',
    },
    email: {
      title: 'Email',
      desc: 'Notify employees via email when a visitor signs in',
      ptitle: 'Please select the mail configuration method',
      defaults: 'Default configuration',
      ddesc: 'In the default configuration, notifications will be sent from the 163 account of the system.',
      tips: 'Successfully modified',
      server1: 'Exchange server',
      server2: 'SMTP server'
    },
    sms: {
      title: 'SMS',
      desc: 'Notify employees via SMS, and use quick replying function notifying visitors.'
    },
    yuyin: {
      title: 'Voice call',
      desc: 'When a visitor signs in on the Pad of the Reception notify the interviewed employee through a voice call.'
    },
    dd: {
      title: 'DingTalk',
      desc: 'Notify the employee via DingTalk when a visitor signs in.',
      tip: 'If you want to turn on this notification method,',
      tip1: 'to set the way to import contacts'
    },
    rtx: {
      title: 'RTX',
      desc: 'Notify employees through RTX when a visitor signs in'
    },
    order: {
      title: 'Reservation authorization',
      desc: 'After opening, the visitors need to be authorized to make a reservation in the service account of “Cool Visit”.'
    },
    invite: {
      title: 'Invitation template',
      desc: 'When the invitation message is sent, the employee clicks on the invitation to see the interview time, place, company culture and so on. After the invitation is edited, the invitation will be available for all the employees.',
      empTitle: 'Restrict employee modification',
      empDesc: 'The invitation template restricts the switch for employee to modify. After the switch is turned on, the employee will not be able to modify the template after login.'
    },
    stagetime: {
      title: 'Term of validity of the Reception verification',
      desc: 'Please set up the time range of the Reception to verify the visitor’s reservation information. If the time is not available, please let the visitor wait. Please ask visitors to make a reservation again if they are over time.',
      preExtendTime: 'before the reservation time:',
      latExtendTime: 'after the reservation time:'
    },
    stageouttime: {
      title: 'The checking time of the Reception',
      desc: 'It set up the time of checking out ',
      text: 'Time:'
    },
    codetime: {
      title: 'Validity period of QR Code',
      desc: 'Please set up the valid time of the QR Code in the invitation.',
      qrMaxCount: 'Maximum time of use for the QR Code:',
      qrMaxDuration: 'Maximum time of use for the QR Code'
    },
    codesign: {
      title: 'Sign in via the QR Code',
      desc: 'After opening, the “QR Code” module will appear in the invitation, which can be used for the scanning verification for the PC barcode scanner at the Reception (on the right side of the list of visitors) and the mobile verification terminal.'
    },
    clogo: {
      title: "Company's Logo",
      desc: "We will show your company's logo on the homepage of the Pad.",
      tip: 'Prompt: Support the JPEG and PNG. It is recommended to choose a PNG picture with transparent background.'
    },
    vset: {
      title: "Visitor's registration",
      desc: 'You can set information of visitors',
      cdesc: 'You can customize the content of guest registration',
      vdesc: 'This information is optional and can be set to visible',
      vselfdesc: 'This is your custom add, required input',
      vselfdesc1: 'This is your custom addition, optional input'
    },
    vpaper: {
      title: "Settings of visitor's card",
      desc: 'You can choose the style, size and content displayed on the card.',
      printType: 'Printer model',
      printBlackType: 'Black and white printing of visitor stickers (suitable for Brother QL-720NW printer)',
      printColorType: 'Color printing of visitor stickers',
      comShow: 'Selection of corporate image display',
      comTextShow: 'Text display (within 6 characters)',
      comPicShow: 'Picture display (recommended size 168x42px)',
      vType: 'Printing style of the visitor sticker',
      cardText: 'Applicable for sticking to the body',
      cardSize: 'Size',
      cardStyle: 'Style',
      cardText1: 'Suitable for 90*60mm card sleeves',
      cardText2: '5-inch standard printing paper',
      cardText3: '4-inch WeChat printing paper',
      codeWinTitle: 'QR Code avatar',
      insertLink: 'Insert a link',
      uploadPic: 'upload picture'
    },
    safe: {
      title: 'Security protocol',
      desc: 'Please click on “Edit” to access the contents of the security protocol, and visitors should read and check "Read" before entering the next step.',
      dialog: {
        title: 'Security protocol settings'
      }
    },
    once: {
      title: 'Once visited',
      desc: 'Visitors only need to enter the phone number to sign in when they visit again.'
    },
    sos: {
      title: 'Logout',
      desc: 'After turning on, the “Logout” button appears on the Pad homepage. Enter phone number to sign out when visitors leave.'
    },
    team: {
      title: 'Team visit',
      desc: 'You can choose to turn on the function to improve the reception efficiency of the team when they visit.',
      dialog: {
        title: 'Default avatar'
      }
    },
    pics: {
      title: 'Rolling pictures on the homepage',
      desc: 'Select two to five pictures representing corporate image, which will be displayed via carousel on the first screen.'
    },
    themecolor: {
      title: 'company color',
      desc: 'You can choose the color to represent your company'
    },
    innerphoto: {
      title: 'Built-in profile picture settings',
      desc: 'Display the built-in profile picture when visitors select "Skip" when taking photos. You can set up a profile picture related to the corporate image. If all the built-in profile picture are deleted, visitors can not skip the photo-taking process.',
      dialog: {
        title: 'Default profile picture'
      }
    },
    facein: {
      title: 'Sign in via face recongnition system',
      desc: 'After turning on, there will be a link of “recognize face to sign in” in the invitation. After uploading the photos of their faces, visitors can sign in by clickling “Reserved Sign-in via face recognition” on the Pad.'
    },
    doorset: {
      title: 'Security settings',
      desc: 'Add guard operations',
      dialog: {
        title: 'Security information settings',
        add: 'Increase the gate'
      },
      signinDoor: 'Sign in the gate',
      signoutDoor: 'Sign out the gate',
      signinGuard: 'Sign in via guard',
      signoutGuard: 'Sign out via guard'
    },
    worktime: {
      title: 'Working time of employees settings',
      desc: 'Please set working hours range so that visitors can open the gate during this period. Remind visitors who haven’t log out after working hours.',
      dialog: {
        title: 'Time settings',
        upDuty: 'Please fill in the starting time.',
        offDuty: 'Please fill in the closing time.'
      }
    },
    coms: {
      title: 'Multi-company service model',
      desc: 'It can be applied to maker space, property and other subjects for office services, providing image display and visitor management services at the Pad terminal for settled companys.',
      dialog: {
        title: 'Corporate Information',
        title1: 'Corporate contact information',
        title2: 'All companies'
      },
      deletetip: {
        title: 'Delete subsidiary',
        desc: 'Are you sure to delete a subsidiary?'
      }
    }
  },
  approve: {
    title: 'Please set up the approval process.',
    desc: 'Please set up the approver according to the visit area. The reservation must be approved via the approver before the adoption.',
    desc1: 'Please set up the approver according to the visittype. The reservation must be approved via the approver before the adoption.',
    atitle: 'Switch of the approval process',
    adesc: 'After the approval function is turned on, the application for access must be approved at multiple levels according to the conditions of approval.',
    astitle: 'Please set up the approval conditions.',
    addArea: 'Add a new area',
    areaName: 'Area name',
    areaAddress: 'Address of the area',
    contact: 'Associate Approver'
  },
  role: {
    rgroup: 'Role group name',
    rolename: 'role name',
    rolegroup: 'the role groups',
    tip: 'Please select the role group',
    tip1: 'Selection of role groups',
    tip2: 'Please choose the role'
  },
  exporttype: {
    title: 'Import through Excel',
    desc1: 'The table needs to include: name, email address, TEL.',
    desc2: 'Excel file format support for csv, xls, xlsx suffixes',
    desc3: 'View the template',
    desc4: 'Click here to modify',
    desc5: 'You have chosen',
    list: ['Import Excel', 'RTX synchronization', 'DingTalk synchronization'],
    desc6: 'You have chosen"',
    desc7: '"as a way of importing the address book.',
    desc8: 'as a way of importing the address book.',
    desc9: 'Synchronize RTX automatically every day at 00:00',
    desc10: 'Synchronize DingTalk automatically every day at 00:00',
    ip: 'IP address',
    ipSet: 'The setting of IP',
    ddSet: 'The setting of DingTalk',
    CorpID: 'CorpID',
    CorpSecret: 'CorpSecret',
    agentid: 'the micro application agentid',
    port: 'Port',
    isNull: 'can not be empty.',
    tip1: 'DingTalk has been turned on and the RTX failed to be turned on.',
    tip2: 'RTX has been turned on and the DingTalk failed to be turned on',
    tip3: 'The DingTalk switch has been turned on and the RTX switch cannot be turned on. If you turn on the RTX, please turn off DingTalk first.',
    tip4: 'The RTX setting is not turned on and the automatic synchronization cannot be turned on.',
    tip5: 'The setting of DingTalk is not turned on, and the automatic synchronization cannot be turned on.',
    tip6: 'The RTX switch has been turned on and the DingTalk switch cannot be turned on. If you turn on the DingTalk, please turn off RTX first.',
    tip7: 'RTX settings are not opened, unable to synchronize the address book',
    tip8: 'The nail setting is not open and can not synchronize the address book'
  },
  emplist: {
    pro: 'Organizational Structure',
    com: 'Role',
    pad1: 'Whether it is not searchable at the Pad terminal',
    pad: 'No appointment',
    cardTip: 'This function is only used for batch issuance of the cards, and the original data will be deleted in the process. The card issuance will last for several minutes.'
  },
  project: {
    pro: 'Project List',
    com: 'Lists of Companies',
    addprotitle: 'New Project',
    proname: 'Project name'
  },
  depart: {
    departName: 'Department name',
    prevDepartName: 'Superior department',
    manager: 'Set up the director',
    selectDepart: 'Select the department',
    hasDepart: 'Selected department',
    dlist: 'Department list',
    selectPrevDepart: 'Select superior department',
    next: 'Subordinate',
    sup: 'The selected item has reached the upper limit',
    tip: 'The main company cannot edit',
    smember: 'Select people',
    hasMember: 'Selected people',
    allEmp: 'All employees',
    noemp: 'The department has no employees'
  },
  picTips: {
    logotip: 'Tip: support JPEG, PNG format, it is recommended that you use a background transparent PNG image',
    slidetip: 'Tip: It is recommended to upload a 1536x2048 pixel image'
  },
  deleteTip: {
    title: 'Delete prompt',
    desc: 'Do you want to delete?',
    success: 'successfully deleted!',
    cancelD: 'Undeleted'
  },
  validPassword: {
    tip1: 'Incorrect password format',
    tip2: 'Password length is not less than 6'
  },
  validEmail: {
    tip1: 'E-mail format is incorrect',
    success: 'Mail sent successfully!',
    tip2: 'please input your email'
  },
  imgcode: {
    tip1: 'verification code must be filled'
  },
  validphone: {
    tip1: 'TEL format is incorrect',
    tip2: 'TEL can not be empty'
  },
  validStage: {
    tip1: 'Account cannot be empty'
  },
  imgCode: 'Change code?',
  homepage: {
    name: 'Website homepage',
    link: '#'
  },
  hlogo: {
    text: '来访通'
  },
  account: {
    siderBar: {
      title: 'Your profile',
      list: [{
        name: 'Basic',
        link: 'base'
      }, {
        name: 'Security',
        link: 'safe'
      }, {
        name: 'Verification account',
        link: 'stage'
      }, {
        name: 'Multi-company',
        link: 'coms'
      }]
    },
    base: {
      title: 'Basic Information'
    },
    safe: {
      title: 'Account Security'
    },
    stage: {
      title: 'Verification account',
      tip: 'Support the verification at the PC terminal and mobile terminal'
    }
  },
  footer: {
    ftext1: 'All Rights Reserved',
    ftext2: 'Nanjing Fangkele Network Technology Co., Ltd. reserves its rights.',
    flink: 'ICP License No. 15058768 via Jiangsu Communications Administration'
  },

  visitorCompany:'Visitor Company',
  recordTime: {
    title:'Visitor record retention time',
    desc:'Set the length of visitor data retention here, 0 means permanent retention',
  },
  qrcodeTime: {
    title:'Frequency of QR Code Use',
    desc:'Configure the frequency of using the QR code, you can swipe up to N times within M minutes',
  },
  month:'Month',
  minute:'Minute',
  times:'times',
}



// WEBPACK FOOTER //
// ./src/lang/en.js